import { render, staticRenderFns } from "./RuleStatusConfirmationModal.vue?vue&type=template&id=3c5a8f43&"
import script from "./RuleStatusConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./RuleStatusConfirmationModal.vue?vue&type=script&lang=js&"
import style0 from "./RuleStatusConfirmationModal.vue?vue&type=style&index=0&id=3c5a8f43&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports